import React from "react";
import "../../styles/Explore.scss";
import Manila from "../../components/assets/Manila.jpg";
import Bora from "../../components/assets/Bora.jpg";
import PalawanLime from "../../components/assets/Palawan-Lime.jpg";

export default function Explore() {
  return (
    <section className="explore-section">
      <div className="explore-content">

        <div className="explore-text">
          <h2>Explore. Discover. Enjoy.</h2>
          <p>
            From the dazzling cityscape of <b>Metro Manila</b> to the white-sand shores 
            of <b>Boracay</b>, the limestone cliffs of <b>Palawan</b>, and the heritage charm 
            of <b>Vigan</b>, every destination tells a story. Whether you're chasing adventure, 
            relaxation, or inspiration, the Philippines delivers an experience that stays 
            with you.
          </p>
        </div>

        <div className="explore-image image-1">
          <img src={Manila} alt="Manila" />
        </div>

        <div className="explore-image image-2">
          <img src={Bora} alt="Boracay" />
        </div>

        <div className="explore-image image-3">
          <img src={PalawanLime} alt="Palawan" />
        </div>

      </div>
    </section>
  );
}
